/**
 * Lanificio: prijs van een kleed in eigen maat. Eén gedeelde functie voor de
 * productpagina (assets/lan-maatwerk.js) en de test (scripts/maatprijs-test.mjs).
 *
 * 1. De drie standaardvarianten krijgen een vaste oppervlakte, op positie:
 *    rechthoekig/organisch 3,68 / 6,00 / 8,75 m² (160 x 230, 200 x 300, 250 x 350),
 *    rond 3,14 / 4,91 / 7,07 m² (Ø 200, Ø 250, Ø 300).
 *    De prijzen P1-P3 zijn de prijzen van die varianten van het product.
 * 2. Oppervlakte eigen maat: b x l / 10000, of pi x (d/2)² / 10000.
 * 3. Lineair tussen de drie punten; eronder de helling van punt 1-2,
 *    erboven de helling van punt 2-3.
 * 4. Maatwerktoeslag x 1,10.  5. Nooit lager dan P1 x 0,75.
 * 6. Naar boven afgerond op een bedrag dat eindigt op 90.
 * 7. Boven € 5.990 of buiten de maatgrenzen: offerte.
 */
(function (root) {
  'use strict';

  var AREAS = {
    rect: [3.68, 6.0, 8.75],
    round: [3.14, 4.91, 7.07],
  };
  var LIMITS = {
    width: { min: 100, max: 400 },
    length: { min: 100, max: 600 },
    diameter: { min: 120, max: 400 },
    step: 5,
  };
  var SURCHARGE = 1.1;
  var FLOOR_FACTOR = 0.75;
  var MAX_PRICE = 5990;

  function interpolate(area, xs, ys) {
    var i = area <= xs[1] ? 0 : 1; // onder of tussen punt 1-2: helling 1-2; daarboven 2-3
    var slope = (ys[i + 1] - ys[i]) / (xs[i + 1] - xs[i]);
    return ys[i] + (area - xs[i]) * slope;
  }

  function roundUpTo90(amount) {
    return Math.ceil((amount - 90) / 100 - 1e-9) * 100 + 90;
  }

  /**
   * @param {{round: boolean, prices: number[], width?: number, length?: number, diameter?: number}} input
   *   prices in euro's (P1, P2, P3); maten in cm
   * @returns {{status: 'ok'|'quote'|'invalid', price?: number, area?: number, base?: number,
   *   width?: number, length?: number, diameter?: number, label?: string, field?: string, message?: string}}
   */
  function calc(input) {
    var prices = (input.prices || []).map(Number);
    if (prices.length < 3 || prices.some(function (p) { return !(p > 0); })) {
      return { status: 'invalid', message: 'Prijs onbekend.' };
    }

    var area, label, out;
    if (input.round) {
      var d = Number(input.diameter);
      var check = checkField('diameter', d);
      if (check) return check;
      area = (Math.PI * Math.pow(d / 2, 2)) / 10000;
      label = 'Ø ' + d + ' cm';
      out = { diameter: d };
    } else {
      var a = Number(input.width);
      var b = Number(input.length);
      // Breedte groter dan lengte: stil omwisselen.
      var w = Math.min(a, b);
      var l = Math.max(a, b);
      var checkW = checkField('width', w, a <= b ? 'width' : 'length');
      if (checkW) return checkW;
      var checkL = checkField('length', l, a <= b ? 'length' : 'width');
      if (checkL) return checkL;
      area = (w * l) / 10000;
      label = w + ' x ' + l + ' cm';
      out = { width: w, length: l };
    }

    var xs = input.round ? AREAS.round : AREAS.rect;
    var base = interpolate(area, xs, prices);
    var withSurcharge = Math.max(base * SURCHARGE, prices[0] * FLOOR_FACTOR);
    var price = roundUpTo90(withSurcharge);

    out.area = area;
    out.base = base;
    out.label = label;
    if (price > MAX_PRICE) {
      out.status = 'quote';
      return out;
    }
    out.status = 'ok';
    out.price = price;
    return out;
  }

  // Leeg, geen getal, te klein of niet in stappen van 5: foutmelding.
  // Te groot: geen fout maar een offerte.
  function checkField(kind, value, field) {
    var lim = LIMITS[kind];
    var name = { width: 'De breedte', length: 'De lengte', diameter: 'De diameter' }[kind];
    field = field || kind;
    if (!isFinite(value) || value <= 0) return { status: 'invalid', field: field, message: 'Vul een maat in cm in.' };
    if (value < lim.min) return { status: 'invalid', field: field, message: name + ' is minimaal ' + lim.min + ' cm.' };
    if (value % LIMITS.step !== 0) {
      return { status: 'invalid', field: field, message: 'Kies een maat in stappen van ' + LIMITS.step + ' cm.' };
    }
    if (value > lim.max) return { status: 'quote', field: field };
    return null;
  }

  var api = { calc: calc, roundUpTo90: roundUpTo90, AREAS: AREAS, LIMITS: LIMITS, MAX_PRICE: MAX_PRICE };
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.LanMaatprijs = api;
})(typeof window !== 'undefined' ? window : globalThis);
